<div class="panel-switch d-inline-flex mb-3">
  <a class="panel-option text-center fs-small fw-800 clickable px-3 py-1"
     [class.active]="panel === 'appointment'" (click)="setPanel('appointment')">
    {{'students.meeting_notes.appointment.tab'|translate}}
  </a>
  <a class="panel-option text-center fs-small fw-800 clickable px-3 py-1"
     [class.active]="panel === 'private'" (click)="setPanel('private')">
    {{'students.meeting_notes.private.tab'|translate}}
  </a>
</div>

<coach-appointment-notes-panel
  *ngIf="panel === 'appointment'" [studentId]="studentId"></coach-appointment-notes-panel>

<coach-student-notes-panel
  *ngIf="panel === 'private'" [studentId]="studentId"></coach-student-notes-panel>
